import Colors from "Common/colors";
import * as React from "react";

const SvgEmailEnvelope = ({
  style = {},
  fill = "none",
  width = 32,
  className = "",
  color = Colors.black,
  viewBox = "0 0 32 32"
}) => (
  <svg
    width={width}
    height={width}
    style={style}
    viewBox={viewBox}
    fill={fill}
    className={`svg-icon ${className || ""}`}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect x="2" y="6" width="28" height="20" rx="2" stroke={color}/>
    <path d="M5 9L16 16L27 9" stroke={color}/>
  </svg>
);

export default SvgEmailEnvelope;
